import { render } from "./appendService.vue?vue&type=template&id=6013587d"
import script from "./appendService.vue?vue&type=script&lang=js"
export * from "./appendService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__